import { useState, useContext, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import TevelCyberLogo from "../../../assets/img/TevelCyberFinalBlueLogo.png";
import LoginImage from "../../../assets/img/LoginIllustraion.png";
import { useNavigate } from "react-router-dom";
import UserService from "../../../services/UserService";
import AuthContext from "../../../auth/AuthContext";
import AlertService from "../../../services/AlertService";
import CyberBay from "../../../assets/img/CyberBayFinalBlueLogo.png";
import MFAIdleTimeout from "./MfaIdleTimeout";

const MFA = () => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [loadingVerify, setLoadingVerify] = useState(false);
  const [loadingSendCode, setLoadingSendCode] = useState(false);
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const submitControllerRef = useRef(null);

  useEffect(() => {
  if (authContext?.mfaVerified) {
    navigate("/");
  }
}, [authContext?.mfaVerified, navigate]);


  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "") {
        if (index > 0) document.getElementById(`otp-${index - 1}`).focus();
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    } else if (e.key === "ArrowRight" && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, 6);
    if (!/^\d+$/.test(pasteData)) return;
    const newOtp = Array(6).fill("");
    [...pasteData].forEach((digit, i) => {
      newOtp[i] = digit;
    });
    setOtp(newOtp);
    const nextIndex = pasteData.length >= 6 ? 5 : pasteData.length;
    document.getElementById(`otp-${nextIndex}`).focus();
  };

const handleSubmit = async (event) => {
  event.preventDefault();
  const finalOtp = otp.join("");
  if (finalOtp.length < 6) return;

  if (submitControllerRef.current) {
    submitControllerRef.current.abort();
  }
  const controller = new AbortController();
  submitControllerRef.current = controller;

  setLoadingVerify(true);

  try {
    const result = await UserService.VerifyQrCode(
      finalOtp,
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (result.isSuccess) {
      authContext.setMFAVerified(true);
      navigate("/");
    } else {
      AlertService.error(result.errorMessage);
    }
  } catch (ex) {
    if (ex.name === "AbortError") return;
    console.error(ex);
  } finally {
    if (!controller.signal.aborted) setLoadingVerify(false);
  }
};

// Unmount cleanup
useEffect(() => {
  return () => {
    submitControllerRef.current?.abort();
  };
}, []);

  const handleSendCode = async () => {
    setLoadingSendCode(true);
    try {
      const result = await UserService.SendOTP(authContext);
      if (result.isSuccess) {
        AlertService.success(result.message);
        navigate("/verifyotp");
      } else {
        AlertService.error(result.errorMessage);
      }
    } catch (ex) {
      console.error(ex);
    } finally {
      setLoadingSendCode(false);
    }
  };

  return (
    <>
    <MFAIdleTimeout/>
    <div className="container-fluid min-vh-100 d-flex flex-column flex-xl-row p-0">
      <div className="col-xl-6 d-flex flex-column justify-content-center align-items-center p-3 p-lg-5 min-vh-100  ">
        <div className="d-none d-xl-block mt-2">
          <img
            src={TevelCyberLogo}
            alt="Company Logo"
            style={{ maxWidth: "217px", marginRight: "220px" }}
            className="img-fluid"
          />
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100">
          <div className="d-flex d-xl-none justify-content-between align-items-center gap-5 mt-3 mb-4">
            <img
              src={TevelCyberLogo}
              alt="Tevel Cyber Logo"
              className="img-fluid"
              style={{ width: "140px" }}
            />
            <img
              src={CyberBay}
              alt="Cyber Bay Logo"
              className="img-fluid"
              style={{ width: "120px" }}
            />
          </div>
          <div className="w-100 mb-xl-4" style={{ maxWidth: "480px" }}>
            <h4 className="mb-2 text-center text-xl-start fw-bold">
              Two Factor Verification
            </h4>
            <p className="mb-3  text-center text-xl-start">
              Please provide the One-Time Password code generated by{" "}
              <strong>Microsoft Authentication </strong> or any{" "}
              <strong>Authentication </strong> app’s in the below textbox
            </p>

            <form onSubmit={handleSubmit} style={{ maxWidth: "440px" }}>
              <div
                className="d-flex justify-content-between mb-4 gap-2"
                onPaste={handlePaste}
              >
                {otp.map((digit, i) => (
                  <input
                    key={i}
                    id={`otp-${i}`}
                    type="text"
                    maxLength="1"
                    inputMode="numeric"
                    className="form-control text-center mfa-input"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, i)}
                    onKeyDown={(e) => handleOtpKeyDown(e, i)}
                    onFocus={(e) => e.target.select()}
                    aria-label={`OTP digit ${i + 1}`}
                    autoComplete="off"
                    autoFocus={i === 0} 
                  />
                ))}
              </div>

              <button
                type="submit"
                className="btn w-100 mb-3  text-white btn-primary custom-input"
                disabled={loadingVerify}
              >
                {loadingVerify ? (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : null}
                {loadingVerify ? "Verifying..." : "Verify"}
              </button>
            </form>
            <div className="text-center mb-4" style={{ maxWidth: "440px" }}>
              I can't use my authenticator app right now
            </div>
            <button
              type="button"
              className="btn w-100   btn-outline-login  custom-input fw-bold "
              onClick={handleSendCode}
              style={{ maxWidth: "440px" }}
              disabled={loadingSendCode}
            >
              {loadingSendCode ? (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : null}
              {loadingSendCode ? "Sending..." : "Send Code via Email"}
            </button>
          </div>
        </div>
        <footer className="mt-auto text-center w-100">
          <p className="text-muted small mb-0">
            © 2026 Tevel Cyber Corps Pvt. Ltd. All rights reserved - Version 2.2.0
          </p>
        </footer>
      </div>
      <div className="col-xl-6 d-none d-xl-flex flex-column login-bg  min-vh-100 align-items-center justify-content-center  ">
        <div className="p-5 mt-2">
          <img
            src={CyberBay}
            alt="CYBER BAY"
            className="img-fluid mb-4"
            width="130px"
          />
        </div>
        <div className='"d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100 p-xl-5 '>
          <img
            src={LoginImage}
            alt="Decorative"
            className="img-fluid loginImg"
            style={{
              maxWidth: "690px",
              maxHeight: "484px",
              marginLeft: "130px",
            }}
          />
        </div>
      </div>
    </div>
    </>
  );
};

export default MFA;
